"use strict";
class $ba884b6af3c1d003$var$Socials extends HTMLElement {
    items = [
        {
            url: "https://atanas.info",
            title: "Go to my website",
            icon: "logo",
            svg: true
        },
        {
            url: "mailto:hi@atanas.info",
            title: "Send me an email",
            icon: "email",
            svg: true
        },
        {
            url: "https://www.linkedin.com/in/scriptex/",
            title: "Find me on LinkedIn",
            icon: "linkedin",
            svg: true
        },
        {
            url: "https://github.com/scriptex",
            title: "See my projects on Github",
            icon: "github",
            svg: true
        },
        {
            url: "https://gitlab.com/scriptex",
            title: "See my projects on Gitlab",
            icon: "gitlab",
            svg: true
        },
        {
            url: "https://twitter.com/scriptexbg",
            title: "Follow me on Twitter",
            icon: "twitter",
            svg: true
        },
        {
            url: "https://www.npmjs.com/~scriptex",
            title: "See my packages on NPM",
            icon: "npm",
            svg: true
        },
        {
            url: "https://www.youtube.com/user/scriptex",
            title: "See my videos on YouTube",
            icon: "youtube",
            svg: true
        },
        {
            url: "https://stackoverflow.com/users/4140082/atanas-atanasov",
            title: "See my profile on StackOverflow",
            icon: "stackoverflow",
            svg: true
        },
        {
            url: "https://codepen.io/scriptex/",
            title: "See my work on Codepen",
            icon: "codepen",
            svg: true
        },
        {
            url: "https://profile.codersrank.io/user/scriptex",
            title: "See my profile on Codersrank",
            icon: "codersrank",
            svg: true
        },
        {
            url: "https://linktr.ee/scriptex",
            title: "See the rest of my links on Linktree",
            icon: "linktree",
            svg: true
        }
    ];
    styleEl = document.createElement("style");
    sprite = document.createElement("template");
    template = document.createElement("template");
    constructor(){
        super();
        this.render();
        const shadowRoot = this.attachShadow({
            mode: "open"
        });
        // prettier-ignore
        this.sprite.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="width: 0; height: 0; position: absolute;"><symbol id="svg-codepen" viewBox="0 0 470 470"><g fill-rule="evenodd"><path d="M234.55 430.576c-108.092 0-196.028-87.939-196.028-196.027S126.458 38.522 234.549 38.522c108.087 0 196.023 87.94 196.023 196.027 0 108.088-87.936 196.027-196.023 196.027M234.55 0C105.01 0 0 105.01 0 234.55s105.008 234.545 234.55 234.545c129.536 0 234.544-105.005 234.544-234.546C469.094 105.01 364.086 0 234.55 0"></path><path d="m354.644 255.407-31.18-20.858 31.18-20.857zM247.012 343.82v-58.133l54.034-36.138 43.62 29.172-97.654 65.1zm-12.463-79.784-44.084-29.486 44.084-29.486 44.08 29.486zm-12.466 79.784-97.653-65.1 43.623-29.172 54.031 36.138v58.133zM114.451 213.692l31.183 20.857-31.183 20.858zm107.632-88.413v58.133l-54.031 36.146-43.623-29.18zm24.929 0 97.654 65.098-43.62 29.181-54.034-36.146V125.28zm132.45 63.458c-.026-.183-.072-.358-.102-.54a12 12 0 0 0-.219-1.047c-.054-.206-.13-.404-.194-.602-.1-.306-.199-.61-.32-.908a12 12 0 0 0-.279-.61 9 9 0 0 0-.423-.824c-.115-.199-.237-.39-.355-.58a14 14 0 0 0-.954-1.298 12 12 0 0 0-.621-.67c-.163-.168-.325-.336-.497-.489a14 14 0 0 0-.705-.595c-.187-.145-.37-.29-.565-.427-.072-.046-.137-.107-.206-.153L241.461 91.62a12.46 12.46 0 0 0-13.828 0l-132.56 88.374c-.07.046-.134.107-.206.153-.196.137-.379.282-.562.427q-.367.286-.705.595c-.175.153-.335.321-.5.488a11 11 0 0 0-1.048 1.213q-.277.366-.524.756a10.4 10.4 0 0 0-.782 1.404c-.094.198-.194.404-.277.61-.122.297-.221.602-.322.908-.065.198-.137.396-.194.602-.091.343-.153.694-.218 1.046-.03.183-.076.358-.099.541a12 12 0 0 0-.114 1.625v88.374c0 .55.041 1.091.114 1.633.023.176.07.358.1.533.064.352.126.702.218 1.046.056.206.129.404.194.603.1.304.199.61.32.915.084.207.183.405.278.603.135.281.272.556.425.831q.169.287.357.572.247.39.523.756c.138.191.282.366.431.541.195.23.401.458.618.672.165.167.325.335.5.487q.339.312.706.596c.183.146.365.29.56.427.073.046.138.107.207.152l132.56 88.375a12.46 12.46 0 0 0 6.916 2.098c2.407 0 4.817-.702 6.911-2.098l132.562-88.375c.07-.045.134-.106.207-.152.194-.137.377-.28.564-.427q.36-.284.705-.596c.172-.152.334-.32.497-.487.216-.214.423-.443.621-.672.146-.175.29-.35.427-.54.188-.245.36-.497.527-.757.118-.19.24-.38.355-.572.156-.275.292-.55.423-.83.095-.199.193-.397.279-.604.121-.305.22-.61.32-.915.065-.199.14-.397.195-.603.091-.344.156-.694.218-1.046.03-.175.075-.357.101-.533.07-.542.113-1.084.113-1.633v-88.374c0-.549-.043-1.09-.113-1.625z"></path></g></symbol><symbol id="svg-codersrank" viewBox="0 0 63 41"><g fill="none" stroke="#FFF"><path fill="#19223C" d="M34.25 1.055 3.147 20.635Q.95 21.964 1.001 23.612v2.98q.052 1.65 2.2 2.926l15.393 8.885a.726.726 0 0 0 1.047-.373l3.456-8.352-7.33-4.15a1.32 1.32 0 0 1-.697-.976 1.345 1.345 0 0 1 .644-1.365l13.457-8.247 5.55-13.512a.32.32 0 0 0-.104-.36.31.31 0 0 0-.369-.013z"></path><path fill="#67A4AC" d="M59.8 11.962 44.618 2.758a.726.726 0 0 0-1.047.32l-3.56 8.352 7.225 4.31c.208.113.381.282.502.488a1.347 1.347 0 0 1-.502 1.853l-13.56 7.98-5.76 13.407a.323.323 0 0 0 .131.515.31.31 0 0 0 .34-.09l9.948-6.011 3.927 5.64a.95.95 0 0 0 .785.425h9.425a.93.93 0 0 0 .832-.506.97.97 0 0 0-.047-.984l-6.388-9.79 12.933-7.82q2.2-1.33 2.2-2.98V14.94q0-1.649-2.2-2.98H59.8z"></path></g></symbol><symbol id="svg-email" viewBox="0 0 15 17"><path fill-rule="evenodd" d="M10.38 14.774v1.556q-1.476.37-2.69.37-3.48 0-5.585-2.207T0 8.648q0-3.673 2.276-6.16Q4.553-.001 7.92 0q2.954 0 4.755 2.017 1.802 2.018 1.802 5.322 0 2.443-.906 3.845-.905 1.402-2.487 1.402-.835 0-1.318-.396-.484-.395-.844-1.388-1.371 1.785-2.804 1.784-1.274 0-2.004-.9-.73-.903-.73-2.484 0-2.355 1.258-3.823Q5.897 3.91 7.91 3.91q.65 0 2.522.158v4.527l.017.817q0 1.705.967 1.705 1.512 0 1.512-3.595 0-2.662-1.389-4.32-1.389-1.656-3.63-1.656-2.628 0-4.495 2.057-1.868 2.056-1.868 4.948 0 2.936 1.731 4.772t4.492 1.837q1.15 0 2.61-.387zm-1.9-9.237a2.2 2.2 0 0 0-.808-.167q-2.285 0-2.285 3.542 0 2.074 1.239 2.074.835 0 1.854-1.678v-3.77z"></path></symbol><symbol id="svg-github" viewBox="0 0 137 131"><path fill-rule="evenodd" d="M9.164 33.44q9.165-15.431 24.868-24.435Q49.734-.001 68.33 0t34.298 9.005q15.705 9.004 24.868 24.434 9.165 15.43 9.164 33.701 0 21.944-13.034 39.472t-33.676 24.26q-2.402.436-3.514-.613c-.742-.699-1.496-1.874-1.496-2.923v-18.322c0-5.653-1.159-9.615-4.243-12.237q5.07-.525 9.12-1.574 4.047-1.05 8.363-3.41 4.315-2.359 7.207-5.813t4.715-9.18q1.824-5.725 1.824-13.156 0-10.58-7.029-18.01 3.293-7.955-.712-17.834-2.49-.787-7.206.962-4.715 1.749-8.186 3.847l-3.38 2.098q-8.275-2.273-17.083-2.273t-17.082 2.273q-1.425-.962-3.782-2.36-2.358-1.4-7.429-3.366-5.07-1.968-7.651-1.18-3.915 9.878-.623 17.834-7.029 7.43-7.029 18.009 0 7.431 1.824 13.113t4.671 9.18q2.847 3.495 7.162 5.857 4.316 2.36 8.363 3.41 4.05 1.047 9.12 1.573-3.56 3.147-4.36 9.004a18 18 0 0 1-4.003 1.312q-2.136.436-5.072.437-2.936 0-5.827-1.88t-4.938-5.464q-1.691-2.797-4.315-4.546-2.625-1.748-4.404-2.098l-1.78-.262q-1.868 0-2.58.393-.712.394-.445 1.006.267.611.8 1.223.535.612 1.158 1.05l.622.437q1.957.874 3.87 3.322t2.803 4.458l.89 2.01q1.157 3.324 3.915 5.377 2.757 2.055 5.96 2.623 3.204.569 6.184.612t4.938-.306l2.77-.975c0 2.215-.03 5.273 0 8.245.03 2.973 0 4.406 0 4.58 0 1.05-1.02 2.225-1.791 2.924q-1.157 1.05-3.559.612-20.641-6.73-33.676-24.26Q0 89.085 0 67.142q0-18.273 9.164-33.704z"></path></symbol><symbol id="svg-gitlab" viewBox="0 0 430 397"><path d="m429.05 226.61-24-74L357.36 6a8.19 8.19 0 0 0-15.58 0l-47.66 146.62H135.88L88.22 6a8.19 8.19 0 0 0-15.58 0L25 152.62l-24 74a16.38 16.38 0 0 0 6 18.31l208 151.16 208.1-151.17a16.38 16.38 0 0 0 6-18.31"></path><path d="m215 396.09 79.12-243.47H135.88z"></path><path fill-opacity=".5" d="m215 396.09-79.12-243.47H25z"></path><path d="m25 152.62-24 74a16.37 16.37 0 0 0 6 18.31l208 151.16zm0 0h110.88L88.22 6a8.19 8.19 0 0 0-15.58 0z"></path><path fill-opacity=".5" d="m215 396.09 79.12-243.47H405z"></path><path d="m405 152.62 24 74a16.37 16.37 0 0 1-6 18.31L215 396.09zM405 152.62H294.12L341.78 6a8.19 8.19 0 0 1 15.58 0z"></path></symbol><symbol id="svg-linkedin" viewBox="0 0 125 118"><path fill-rule="evenodd" d="M0 13.745Q0 7.797 4.191 3.9 8.382 0 15.137 0c6.755 0 8.11 1.3 10.823 3.899q4.07 3.898 4.15 9.846.082 5.868-4.109 9.807T14.974 27.49h-.163q-6.674 0-10.742-3.938Q-.001 19.613 0 13.745M1.546 118V38.342h26.856V118zm41.667 0q.162-32.073.163-52.007c.001-19.934-.027-21.22-.082-23.793l-.081-3.858h26.774v11.575h-.163q1.627-2.572 3.337-4.501t4.598-4.18q2.889-2.25 7.08-3.497 4.191-1.245 9.318-1.246 13.916 0 22.38 9.123 8.462 9.125 8.463 26.727V118H98.226V75.398q0-8.44-3.296-13.223-3.296-4.782-10.295-4.783-5.127 0-8.585 2.774a17.1 17.1 0 0 0-5.168 6.872q-.895 2.412-.895 6.511V118z"></path></symbol><symbol id="svg-linktree" viewBox="0 0 30 25"><path fill="#39E09B" d="M11.2.688c-.5-.9-1.8-.9-2.3 0l-8.6 15.6c-.399.8.2 1.7 1.101 1.7h5.8v5.9c0 .6.5 1.1 1.1 1.1h3.4c.6 0 1.1-.5 1.1-1.1v-5.9h-1.6c-.7 0-1.2-.5-1.3-1.1 0-.2 0-.4.1-.601l4.8-8.7z"></path><path fill="#28BF7B" d="M18.8.688c.5-.9 1.8-.9 2.3 0l8.601 15.6c.399.8-.2 1.7-1.101 1.7h-5.7v5.9c0 .6-.5 1.1-1.101 1.1h-3.6a1.11 1.11 0 0 1-1.101-1.1v-5.9H18.7c.7 0 1.2-.5 1.3-1.1 0-.2 0-.4-.1-.601l-4.801-8.7z"></path></symbol><symbol id="svg-logo" viewBox="0 0 206 206"><g fill-rule="evenodd" transform="translate(3 3)"><circle cx="100" cy="100" r="100" fill="none" stroke="currentColor" stroke-width="4"></circle><path d="m37.938 136.266 23.285-59.154 14.117 39.867 7.52 19.287h15.43L70.163 64H55.125L27 136.266m105.22 10.459v-9.327q-12.987-13.086-12.988-37.06 0-23.925 12.989-37.012V54q-12.11 6.738-19.165 19.238-7.056 12.5-7.056 27.1c0 14.6 2.393 18.831 7.178 27.295q7.178 12.694 19.043 19.092zm8.78 0q11.865-6.398 19.043-19.092 7.178-12.696 7.178-27.295c0-14.599-2.352-18.766-7.056-27.1Q153.109 60.738 141 54v9.326q12.988 13.086 12.988 37.012 0 23.974-12.988 37.06z"></path></g></symbol><symbol id="svg-npm" viewBox="0 0 55 55"><path d="M0 0v55h55V0zm45 45h-7.02V17.02H27.5V45H10V10h35z"></path></symbol><symbol id="svg-stackoverflow" viewBox="0 0 110 118"><path d="M84.072 107.351V75.8h10.516v42.069H0V75.8h10.516v31.551z"></path><path d="m22.089 72.898 51.458 10.815 2.163-10.292-51.458-10.815zm6.808-24.639 47.666 22.199 4.44-9.533-47.666-22.199zm13.191-23.385 40.405 33.65 6.73-8.081-40.405-33.65zM68.171 0l-8.438 6.276 31.381 42.191 8.438-6.276zM21.044 96.833h52.582V86.316H21.044z"></path></symbol><symbol id="svg-twitter" viewBox="0 0 134 106"><path fill-rule="evenodd" d="M0 93.992q2.96.331 6.596.331 19.029 0 33.912-11.428-8.88-.165-15.899-5.341-7.02-5.175-9.64-13.209 2.79.414 5.158.414 3.636 0 7.188-.91-9.471-1.905-15.687-9.234c-6.216-7.329-6.216-10.559-6.216-17.018v-.331q5.751 3.147 12.347 3.395-5.58-3.645-8.88-9.523-3.297-5.88-3.298-12.754 0-7.287 3.721-13.498 10.233 12.34 24.906 19.75 14.672 7.413 31.417 8.24a29 29 0 0 1-.677-6.128q0-11.097 7.992-18.922T92.264 0q11.839 0 19.958 8.447a54.3 54.3 0 0 0 17.336-6.46q-3.129 9.525-12.009 14.741 7.866-.828 15.73-4.14a56.6 56.6 0 0 1-13.7 13.83q.084 1.158.085 3.477 0 10.765-3.214 21.49t-9.768 20.58a81.4 81.4 0 0 1-15.602 17.43q-9.05 7.578-21.819 12.09-12.77 4.514-27.315 4.514-22.918 0-41.946-12.008z"></path></symbol><symbol id="svg-youtube" viewBox="0 0 512 512"><path d="M490.24 113.92c-13.888-24.704-28.96-29.248-59.648-30.976C399.936 80.864 322.848 80 256.064 80c-66.912 0-144.032.864-174.656 2.912-30.624 1.76-45.728 6.272-59.744 31.008C7.36 138.592 0 181.088 0 255.904v.256c0 74.496 7.36 117.312 21.664 141.728 14.016 24.704 29.088 29.184 59.712 31.264C112.032 430.944 189.152 432 256.064 432c66.784 0 143.872-1.056 174.56-2.816 30.688-2.08 45.76-6.56 59.648-31.264C504.704 373.504 512 330.688 512 256.192v-.256c0-74.848-7.296-117.344-21.76-142.016M192 352V160l160 96z"></path></symbol></svg>';
        this.styleEl.innerHTML = `ul {
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	justify-content: center;
	padding: 0;
	margin: 0;
	list-style: none outside none;
}

li {
	padding: 0.5rem 0.325rem;
}

li a,
li svg {
	color: inherit;
	display: block;
}

img {
	vertical-align: middle;
}

li svg {
	fill: currentColor;
}

.svg-npm,
.svg-email,
.svg-github,
.svg-gitlab,
.svg-twitter,
.svg-codepen,
.svg-linkedin,
.svg-google-plus,
.svg-stackoverflow {
	width: 1.5rem;
}

.svg-npm,
.svg-codepen,
.svg-youtube,
.svg-linktree,
.svg-codersrank,
.svg-google-plus,
.svg-stackoverflow {
	height: 1.5rem;
}

.svg-npm {
	border-radius: 0.25rem;
}

.svg-email {
	height: 1.69rem;
}

.svg-github,
.svg-gitlab,
.svg-linkedin {
	height: 1.63rem;
}

.svg-twitter {
	height: 1.38rem;
}

.svg-youtube {
	width: 2rem;
}

.svg-logo {
	width: 1.75rem;
	height: 1.75rem;
	stroke: currentColor;
	stroke-width: 0.325rem;
}

.svg-codersrank {
	width: 2.5rem;
}

.svg-linktree {
	width: 1.75rem;
}
`;
        shadowRoot.appendChild(this.styleEl.cloneNode(true));
        shadowRoot.appendChild(this.sprite.content.cloneNode(true));
        shadowRoot.appendChild(this.template.content.cloneNode(true));
    }
    render() {
        this.template.innerHTML = `<ul>${this.renderList()}</ul>`;
    }
    renderList() {
        return this.items.map((item)=>`<li>
					<a href="${item.url}" target="_blank" rel="noopener noreferrer" title="${item.title}">
						${this.renderIcon(item)}
					</a>
				</li>`).join("\n");
    }
    renderIcon(item) {
        return item.svg ? `<svg class="svg-${item.icon}"><use xlink:href="#svg-${item.icon}"></use></svg>` : `<img src="${item.icon}" alt="" width="24" loading="lazy" />`;
    }
}
customElements.define("social-links", $ba884b6af3c1d003$var$Socials);


var $d40ac4c82ef1fee8$exports = {};
"use strict";
var $d40ac4c82ef1fee8$var$__awaiter = $d40ac4c82ef1fee8$exports && $d40ac4c82ef1fee8$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d40ac4c82ef1fee8$var$__rest = $d40ac4c82ef1fee8$exports && $d40ac4c82ef1fee8$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $d40ac4c82ef1fee8$var$HTMLHeadComponent extends HTMLElement {
    constructor(){
        super();
        this.data = [];
        this.elements = [];
    }
    static get observedAttributes() {
        return [
            "data",
            "src"
        ];
    }
    connectedCallback() {
        return $d40ac4c82ef1fee8$var$__awaiter(this, void 0, void 0, function*() {
            const src = this.getAttribute("src");
            const data = this.getAttribute("data");
            this.removeElements();
            this.data = src ? yield this.fetchData(src) : this.parseAttribute(data);
            this.createElements();
        });
    }
    attributeChangedCallback(name, _, newValue) {
        return $d40ac4c82ef1fee8$var$__awaiter(this, void 0, void 0, function*() {
            if (name !== "data") return;
            this.removeElements();
            this.data = this.parseAttribute(newValue);
            this.createElements();
        });
    }
    removeElements() {
        for (const el of this.elements)document.head.removeChild(el);
        this.elements = [];
    }
    createElements() {
        for (const item of this.data){
            const { tag: tag } = item, attrs = $d40ac4c82ef1fee8$var$__rest(item, [
                "tag"
            ]);
            if (tag === "title") {
                document.title = attrs.content || "";
                continue;
            }
            document.head.appendChild(this.createElement(tag, attrs));
        }
    }
    createElement(tag, attrs) {
        const el = document.createElement(tag);
        Object.keys(attrs).forEach((attr)=>{
            const attribute = attr.substring(0, 3) === "og:" ? "property" : attr;
            if (this.hasContent(attr, tag)) el.innerHTML = attrs[attr];
            else el.setAttribute(attribute, attrs[attr] || "&nbsp;");
        });
        this.elements.push(el);
        return el;
    }
    hasContent(attr, tag) {
        return attr === "content" && [
            "style",
            "script",
            "noscript"
        ].includes(tag);
    }
    parseAttribute(value) {
        if (!value) return [];
        try {
            return JSON.parse(value);
        } catch (e) {
            return [];
        }
    }
    fetchData(src) {
        return $d40ac4c82ef1fee8$var$__awaiter(this, void 0, void 0, function*() {
            return fetch(src).then((r)=>r.json());
        });
    }
}
window.customElements.define("html-head-component", $d40ac4c82ef1fee8$var$HTMLHeadComponent);


class $7bbf6eed0b3cd803$export$2e2bcd8739ae039 {
    size;
    cells;
    constructor(size){
        this.size = size;
        this.cells = [];
        this.build();
    }
    getAvailableCell = ()=>{
        const cells = this.availableCells();
        if (!cells.length) return null;
        return cells[Math.floor(Math.random() * cells.length)];
    };
    eachCell = (callback)=>{
        for(let x = 0; x < this.size; x++)for(let y = 0; y < this.size; y++)callback(x, y, this.cells[x][y]);
    };
    hasCellsAvailable = ()=>!!this.availableCells().length;
    isCellAvailable = (cell)=>!this.isCellOccupied(cell);
    getCellContent = (cell)=>this.isInBounds(cell) ? this.cells[cell.x][cell.y] : null;
    insertTile = (tile)=>{
        this.cells[tile.x][tile.y] = tile;
    };
    removeTile = (tile)=>{
        this.cells[tile.x][tile.y] = null;
    };
    isInBounds = (position)=>{
        return position.x >= 0 && position.x < this.size && position.y >= 0 && position.y < this.size;
    };
    build = ()=>{
        for(let x = 0; x < this.size; x++){
            const row = this.cells[x] = [];
            for(let y = 0; y < this.size; y++)row.push(null);
        }
    };
    availableCells = ()=>{
        const cells = [];
        this.eachCell((x, y, tile)=>{
            if (!tile) cells.push({
                x: x,
                y: y
            });
        });
        return cells;
    };
    isCellOccupied = (cell)=>!!this.getCellContent(cell);
}


class $960a2cfa9ab53929$export$2e2bcd8739ae039 {
    x;
    y;
    value;
    mergedFrom;
    prevPosition;
    constructor(position, value){
        this.x = position.x;
        this.y = position.y;
        this.value = value || 2;
        this.mergedFrom = null;
        this.prevPosition = null;
    }
    save = ()=>{
        this.prevPosition = {
            x: this.x,
            y: this.y
        };
    };
    update = (position)=>{
        this.x = position.x;
        this.y = position.y;
    };
}


class $fd629d3925992730$export$2e2bcd8739ae039 {
    tileContainer;
    scoreContainer;
    messageContainer;
    bestScoreContainer;
    score;
    storageKey;
    constructor(){
        this.tileContainer = document.querySelector(".tiles");
        this.scoreContainer = document.querySelector(".current-score");
        this.messageContainer = document.querySelector(".message");
        this.bestScoreContainer = document.querySelector(".best-score");
        this.score = 0;
        this.storageKey = "2048-best-score";
        this.updateBestScore();
    }
    update = (grid, metadata)=>{
        window.requestAnimationFrame(()=>{
            this.clearContainer(this.tileContainer);
            grid.cells.forEach((column)=>{
                column.forEach((cell)=>{
                    if (cell) this.addTile(cell);
                });
            });
            this.updateScore(metadata.score);
            if (metadata.isOver) this.getMessage(false);
            if (metadata.isWin) this.getMessage(true);
        });
    };
    restart = ()=>{
        this.clearMessage();
    };
    clearContainer = (container)=>{
        while(container.firstChild)container.removeChild(container.firstChild);
    };
    addTile = (tile)=>{
        const element = document.createElement("div");
        const position = tile.prevPosition || {
            x: tile.x,
            y: tile.y
        };
        const getPositionClass = this.getPositionClass(position);
        const classes = [
            "tile",
            "tile-" + tile.value,
            getPositionClass
        ];
        this.setClass(element, classes);
        element.textContent = tile.value.toString();
        if (tile.prevPosition) window.requestAnimationFrame(()=>{
            classes[2] = this.getPositionClass({
                x: tile.x,
                y: tile.y
            });
            this.setClass(element, classes);
        });
        else if (tile.mergedFrom) {
            classes.push("tile-merged");
            this.setClass(element, classes);
            tile.mergedFrom.forEach((merged)=>{
                this.addTile(merged);
            });
        } else {
            classes.push("tile-new");
            this.setClass(element, classes);
        }
        this.tileContainer.appendChild(element);
    };
    setClass = (element, classes)=>{
        element.setAttribute("class", classes.join(" "));
    };
    normalizePosition = (position)=>({
            x: position.x + 1,
            y: position.y + 1
        });
    getPositionClass = (position)=>{
        const { x: x, y: y } = this.normalizePosition(position);
        return `tile-position-${x}-${y}`;
    };
    updateScore = (score)=>{
        const difference = score - this.score;
        this.score = score;
        this.clearContainer(this.scoreContainer);
        this.scoreContainer.textContent = this.score.toString();
        if (difference > 0) {
            const addition = document.createElement("div");
            addition.classList.add("score-addition");
            addition.textContent = "+" + difference;
            this.scoreContainer.appendChild(addition);
            this.updateBestScore();
        }
    };
    updateBestScore = ()=>{
        const bestScore = localStorage.getItem(this.storageKey) || "";
        const currentScore = this.score;
        if (!bestScore) localStorage.setItem(this.storageKey, currentScore.toString());
        if (bestScore && currentScore > parseInt(bestScore, 10)) localStorage.setItem(this.storageKey, currentScore.toString());
        this.bestScoreContainer.textContent = localStorage.getItem(this.storageKey);
    };
    getMessage = (isWin)=>{
        const type = isWin ? "game-won" : "game-over";
        const message = isWin ? "You win!" : "Game over!";
        this.messageContainer.classList.add(type);
        this.messageContainer.querySelector("p").textContent = message;
    };
    clearMessage = ()=>{
        this.messageContainer.classList.remove("game-won", "game-over");
    };
}


var $631a4ac5e6b8f660$exports = {};
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */ (function(window1, document1, exportName, undefined) {
    "use strict";
    var VENDOR_PREFIXES = [
        "",
        "webkit",
        "Moz",
        "MS",
        "ms",
        "o"
    ];
    var TEST_ELEMENT = document1.createElement("div");
    var TYPE_FUNCTION = "function";
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    /**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */ function setTimeoutContext(fn, timeout, context) {
        return setTimeout(bindFn(fn, context), timeout);
    }
    /**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }
        return false;
    }
    /**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function each(obj, iterator, context) {
        var i;
        if (!obj) return;
        if (obj.forEach) obj.forEach(iterator, context);
        else if (obj.length !== undefined) {
            i = 0;
            while(i < obj.length){
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
    }
    /**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function deprecate(method, name, message) {
        var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message + " AT \n";
        return function() {
            var e = new Error("get-stack-trace");
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace";
            var log = window1.console && (window1.console.warn || window1.console.log);
            if (log) log.call(window1.console, deprecationMessage, stack);
            return method.apply(this, arguments);
        };
    }
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var assign;
    if (typeof Object.assign !== "function") assign = function assign(target) {
        if (target === undefined || target === null) throw new TypeError("Cannot convert undefined or null to object");
        var output = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
            }
        }
        return output;
    };
    else assign = Object.assign;
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var extend = deprecate(function extend(dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;
        while(i < keys.length){
            if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
            i++;
        }
        return dest;
    }, "extend", "Use `assign`.");
    /**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var merge = deprecate(function merge(dest, src) {
        return extend(dest, src, true);
    }, "merge", "Use `assign`.");
    /**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function inherit(child, base, properties) {
        var baseP = base.prototype, childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) assign(childP, properties);
    }
    /**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function boolOrFn(val, args) {
        if (typeof val == TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
        return val;
    }
    /**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */ function ifUndefined(val1, val2) {
        return val1 === undefined ? val2 : val1;
    }
    /**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function addEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function removeEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function hasParent(node, parent) {
        while(node){
            if (node == parent) return true;
            node = node.parentNode;
        }
        return false;
    }
    /**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) return src.indexOf(find);
        else {
            var i = 0;
            while(i < src.length){
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) return i;
                i++;
            }
            return -1;
        }
    }
    /**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while(i < src.length){
            var val = key ? src[i][key] : src[i];
            if (inArray(values, val) < 0) results.push(src[i]);
            values[i] = val;
            i++;
        }
        if (sort) {
            if (!key) results = results.sort();
            else results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
        return results;
    }
    /**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function prefixed(obj, property) {
        var prefix, prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while(i < VENDOR_PREFIXES.length){
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;
            if (prop in obj) return prop;
            i++;
        }
        return undefined;
    }
    /**
 * get a unique id
 * @returns {number} uniqueId
 */ var _uniqueId = 1;
    function uniqueId() {
        return _uniqueId++;
    }
    /**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window1;
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = "ontouchstart" in window1;
    var SUPPORT_POINTER_EVENTS = prefixed(window1, "PointerEvent") !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = "touch";
    var INPUT_TYPE_PEN = "pen";
    var INPUT_TYPE_MOUSE = "mouse";
    var INPUT_TYPE_KINECT = "kinect";
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = [
        "x",
        "y"
    ];
    var PROPS_CLIENT_XY = [
        "clientX",
        "clientY"
    ];
    /**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ function Input(manager, callback) {
        var self1 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget;
        // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if (boolOrFn(manager.options.enable, [
                manager
            ])) self1.handler(ev);
        };
        this.init();
    }
    Input.prototype = {
        /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */ handler: function() {},
        /**
     * bind the events
     */ init: function() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        },
        /**
     * unbind the events
     */ destroy: function() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        }
    };
    /**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function createInputInstance(manager) {
        var Type;
        var inputClass = manager.options.inputClass;
        if (inputClass) Type = inputClass;
        else if (SUPPORT_POINTER_EVENTS) Type = PointerEventInput;
        else if (SUPPORT_ONLY_TOUCH) Type = TouchInput;
        else if (!SUPPORT_TOUCH) Type = MouseInput;
        else Type = TouchMouseInput;
        return new Type(manager, inputHandler);
    }
    /**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) manager.session = {};
        // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'
        input.eventType = eventType;
        // compute scale, rotation etc
        computeInputData(manager, input);
        // emit secret event
        manager.emit("hammer.input", input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length;
        // store the first input to calculate the distance and direction
        if (!session.firstInput) session.firstInput = simpleCloneInputData(input);
        // to compute scale and rotation we need to store the multiple touches
        if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = simpleCloneInputData(input);
        else if (pointersLength === 1) session.firstMultiple = false;
        var firstInput = session.firstInput;
        var firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input);
        // find the correct target
        var target = manager.element;
        if (hasParent(input.srcEvent.target, target)) target = input.srcEvent.target;
        input.target = target;
    }
    function computeDeltaXY(session, input) {
        var center = input.center;
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
        if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;
        while(i < input.pointers.length){
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }
        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function getCenter(pointers) {
        var pointersLength = pointers.length;
        // no need to loop when only one touch
        if (pointersLength === 1) return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
        var x = 0, y = 0, i = 0;
        while(i < pointersLength){
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }
        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function getDirection(x, y) {
        if (x === y) return DIRECTION_NONE;
        if (abs(x) >= abs(y)) return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    /**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function getDistance(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function getAngle(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = "mousedown";
    var MOUSE_WINDOW_EVENTS = "mousemove mouseup";
    /**
 * Mouse events input
 * @constructor
 * @extends Input
 */ function MouseInput() {
        this.evEl = MOUSE_ELEMENT_EVENTS;
        this.evWin = MOUSE_WINDOW_EVENTS;
        this.pressed = false; // mousedown state
        Input.apply(this, arguments);
    }
    inherit(MouseInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function MEhandler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type];
            // on start we want to have the left mouse button down
            if (eventType & INPUT_START && ev.button === 0) this.pressed = true;
            if (eventType & INPUT_MOVE && ev.which !== 1) eventType = INPUT_END;
            // mouse must be down
            if (!this.pressed) return;
            if (eventType & INPUT_END) this.pressed = false;
            this.callback(this.manager, eventType, {
                pointers: [
                    ev
                ],
                changedPointers: [
                    ev
                ],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        }
    });
    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    };
    // in IE10 the pointer types is defined as an enum
    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = "pointerdown";
    var POINTER_WINDOW_EVENTS = "pointermove pointerup pointercancel";
    // IE10 has prefixed support, and case-sensitive
    if (window1.MSPointerEvent && !window1.PointerEvent) {
        POINTER_ELEMENT_EVENTS = "MSPointerDown";
        POINTER_WINDOW_EVENTS = "MSPointerMove MSPointerUp MSPointerCancel";
    }
    /**
 * Pointer events input
 * @constructor
 * @extends Input
 */ function PointerEventInput() {
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        Input.apply(this, arguments);
        this.store = this.manager.session.pointerEvents = [];
    }
    inherit(PointerEventInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function PEhandler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace("ms", "");
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType == INPUT_TYPE_TOUCH;
            // get index of the event in the store
            var storeIndex = inArray(store, ev.pointerId, "pointerId");
            // start and mouse must be down
            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) removePointer = true;
            // it not found, so the pointer hasn't been down (so it's probably a hover)
            if (storeIndex < 0) return;
            // update the event in the store
            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [
                    ev
                ],
                pointerType: pointerType,
                srcEvent: ev
            });
            if (removePointer) // remove from the store
            store.splice(storeIndex, 1);
        }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = "touchstart";
    var SINGLE_TOUCH_WINDOW_EVENTS = "touchstart touchmove touchend touchcancel";
    /**
 * Touch events input
 * @constructor
 * @extends Input
 */ function SingleTouchInput() {
        this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        this.started = false;
        Input.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input, {
        handler: function TEhandler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
            // should we handle the touch events?
            if (type === INPUT_START) this.started = true;
            if (!this.started) return;
            var touches = normalizeSingleTouches.call(this, ev, type);
            // when done, reset the started state
            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) all = uniqueArray(all.concat(changed), "identifier", true);
        return [
            all,
            changed
        ];
    }
    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = "touchstart touchmove touchend touchcancel";
    /**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ function TouchInput() {
        this.evTarget = TOUCH_TARGET_EVENTS;
        this.targetIds = {};
        Input.apply(this, arguments);
    }
    inherit(TouchInput, Input, {
        handler: function MTEhandler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);
            if (!touches) return;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds;
        // when there is only one touch, the process can be simplified
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [
                allTouches,
                allTouches
            ];
        }
        var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
        // get target touches from touches
        targetTouches = allTouches.filter(function(touch) {
            return hasParent(touch.target, target);
        });
        // collect touches
        if (type === INPUT_START) {
            i = 0;
            while(i < targetTouches.length){
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        }
        // filter changed touches to only contain touches that exist in the collected target ids
        i = 0;
        while(i < changedTouches.length){
            if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
            // cleanup removed touches
            if (type & (INPUT_END | INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
            i++;
        }
        if (!changedTargetTouches.length) return;
        return [
            // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), "identifier", true),
            changedTargetTouches
        ];
    }
    /**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function TouchMouseInput() {
        Input.apply(this, arguments);
        var handler = bindFn(this.handler, this);
        this.touch = new TouchInput(this.manager, handler);
        this.mouse = new MouseInput(this.manager, handler);
        this.primaryTouch = null;
        this.lastTouches = [];
    }
    inherit(TouchMouseInput, Input, {
        /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ handler: function TMEhandler(manager, inputEvent, inputData) {
            var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
            if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
            // when we're in a touch event, record touches to  de-dupe synthetic mouse event
            if (isTouch) recordTouches.call(this, inputEvent, inputData);
            else if (isMouse && isSyntheticEvent.call(this, inputData)) return;
            this.callback(manager, inputEvent, inputData);
        },
        /**
     * remove the event listeners
     */ destroy: function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        }
    });
    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) setLastTouch.call(this, eventData);
    }
    function setLastTouch(eventData) {
        var touch = eventData.changedPointers[0];
        if (touch.identifier === this.primaryTouch) {
            var lastTouch = {
                x: touch.clientX,
                y: touch.clientY
            };
            this.lastTouches.push(lastTouch);
            var lts = this.lastTouches;
            var removeLastTouch = function() {
                var i = lts.indexOf(lastTouch);
                if (i > -1) lts.splice(i, 1);
            };
            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }
    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
        for(var i = 0; i < this.lastTouches.length; i++){
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) return true;
        }
        return false;
    }
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, "touchAction");
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
    // magical touchAction value
    var TOUCH_ACTION_COMPUTE = "compute";
    var TOUCH_ACTION_AUTO = "auto";
    var TOUCH_ACTION_MANIPULATION = "manipulation"; // not implemented
    var TOUCH_ACTION_NONE = "none";
    var TOUCH_ACTION_PAN_X = "pan-x";
    var TOUCH_ACTION_PAN_Y = "pan-y";
    var TOUCH_ACTION_MAP = getTouchActionProps();
    /**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    TouchAction.prototype = {
        /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */ set: function(value) {
            // find out the touch-action by the event handlers
            if (value == TOUCH_ACTION_COMPUTE) value = this.compute();
            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            this.actions = value.toLowerCase().trim();
        },
        /**
     * just re-set the touchAction value
     */ update: function() {
            this.set(this.manager.options.touchAction);
        },
        /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */ compute: function() {
            var actions = [];
            each(this.manager.recognizers, function(recognizer) {
                if (boolOrFn(recognizer.options.enable, [
                    recognizer
                ])) actions = actions.concat(recognizer.getTouchAction());
            });
            return cleanTouchActions(actions.join(" "));
        },
        /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */ preventDefaults: function(input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection;
            // if the touch action did prevented once this session
            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }
            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
            if (hasNone) {
                //do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;
                if (isTapPointer && isTapMovement && isTapTouchTime) return;
            }
            if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
        },
        /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */ preventSrc: function(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        }
    };
    /**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) return TOUCH_ACTION_NONE;
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning
        if (hasPanX && hasPanY) return TOUCH_ACTION_NONE;
        // pan-x OR pan-y
        if (hasPanX || hasPanY) return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        // manipulation
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) return TOUCH_ACTION_MANIPULATION;
        return TOUCH_ACTION_AUTO;
    }
    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) return false;
        var touchMap = {};
        var cssSupports = window1.CSS && window1.CSS.supports;
        [
            "auto",
            "manipulation",
            "pan-y",
            "pan-x",
            "pan-x pan-y",
            "none"
        ].forEach(function(val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            touchMap[val] = cssSupports ? window1.CSS.supports("touch-action", val) : true;
        });
        return touchMap;
    }
    /**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ function Recognizer(options) {
        this.options = assign({}, this.defaults, options || {});
        this.id = uniqueId();
        this.manager = null;
        // default is enable true
        this.options.enable = ifUndefined(this.options.enable, true);
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    Recognizer.prototype = {
        /**
     * @virtual
     * @type {Object}
     */ defaults: {},
        /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */ set: function(options) {
            assign(this.options, options);
            // also update the touchAction, in case something changed about the directions/enabled state
            this.manager && this.manager.touchAction.update();
            return this;
        },
        /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ recognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "recognizeWith", this)) return this;
            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }
            return this;
        },
        /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRecognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "dropRecognizeWith", this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        },
        /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ requireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "requireFailure", this)) return this;
            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }
            return this;
        },
        /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRequireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "dropRequireFailure", this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);
            if (index > -1) this.requireFail.splice(index, 1);
            return this;
        },
        /**
     * has require failures boolean
     * @returns {boolean}
     */ hasRequireFailures: function() {
            return this.requireFail.length > 0;
        },
        /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */ canRecognizeWith: function(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        },
        /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */ emit: function(input) {
            var self1 = this;
            var state = this.state;
            function emit(event) {
                self1.manager.emit(event, input);
            }
            // 'panstart' and 'panmove'
            if (state < STATE_ENDED) emit(self1.options.event + stateStr(state));
            emit(self1.options.event); // simple 'eventName' events
            if (input.additionalEvent) emit(input.additionalEvent);
            // panend and pancancel
            if (state >= STATE_ENDED) emit(self1.options.event + stateStr(state));
        },
        /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */ tryEmit: function(input) {
            if (this.canEmit()) return this.emit(input);
            // it's failing anyway
            this.state = STATE_FAILED;
        },
        /**
     * can we emit?
     * @returns {boolean}
     */ canEmit: function() {
            var i = 0;
            while(i < this.requireFail.length){
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) return false;
                i++;
            }
            return true;
        },
        /**
     * update the recognizer
     * @param {Object} inputData
     */ recognize: function(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign({}, inputData);
            // is is enabled and allow recognizing?
            if (!boolOrFn(this.options.enable, [
                this,
                inputDataClone
            ])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            }
            // reset when we've reached the end
            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) this.state = STATE_POSSIBLE;
            this.state = this.process(inputDataClone);
            // the recognizer has recognized a gesture
            // so trigger an event
            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) this.tryEmit(inputDataClone);
        },
        /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */ process: function(inputData) {},
        /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */ getTouchAction: function() {},
        /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */ reset: function() {}
    };
    /**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */ function stateStr(state) {
        if (state & STATE_CANCELLED) return "cancel";
        else if (state & STATE_ENDED) return "end";
        else if (state & STATE_CHANGED) return "move";
        else if (state & STATE_BEGAN) return "start";
        return "";
    }
    /**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */ function directionStr(direction) {
        if (direction == DIRECTION_DOWN) return "down";
        else if (direction == DIRECTION_UP) return "up";
        else if (direction == DIRECTION_LEFT) return "left";
        else if (direction == DIRECTION_RIGHT) return "right";
        return "";
    }
    /**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) return manager.get(otherRecognizer);
        return otherRecognizer;
    }
    /**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ function AttrRecognizer() {
        Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof AttrRecognizer
     */ defaults: {
            /**
         * @type {Number}
         * @default 1
         */ pointers: 1
        },
        /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */ attrTest: function(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        },
        /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */ process: function(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input);
            // on cancel input and we've recognized before, return STATE_CANCELLED
            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) return state | STATE_CANCELLED;
            else if (isRecognized || isValid) {
                if (eventType & INPUT_END) return state | STATE_ENDED;
                else if (!(state & STATE_BEGAN)) return STATE_BEGAN;
                return state | STATE_CHANGED;
            }
            return STATE_FAILED;
        }
    });
    /**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function PanRecognizer() {
        AttrRecognizer.apply(this, arguments);
        this.pX = null;
        this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PanRecognizer
     */ defaults: {
            event: "pan",
            threshold: 10,
            pointers: 1,
            direction: DIRECTION_ALL
        },
        getTouchAction: function() {
            var direction = this.options.direction;
            var actions = [];
            if (direction & DIRECTION_HORIZONTAL) actions.push(TOUCH_ACTION_PAN_Y);
            if (direction & DIRECTION_VERTICAL) actions.push(TOUCH_ACTION_PAN_X);
            return actions;
        },
        directionTest: function(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY;
            // lock to axis?
            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x != this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y != this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }
            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        },
        attrTest: function(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        },
        emit: function(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);
            if (direction) input.additionalEvent = this.options.event + direction;
            this._super.emit.call(this, input);
        }
    });
    /**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ function PinchRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: "pinch",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        },
        emit: function(input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? "in" : "out";
                input.additionalEvent = this.options.event + inOut;
            }
            this._super.emit.call(this, input);
        }
    });
    /**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ function PressRecognizer() {
        Recognizer.apply(this, arguments);
        this._timer = null;
        this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PressRecognizer
     */ defaults: {
            event: "press",
            pointers: 1,
            time: 251,
            threshold: 9 // a minimal movement is ok, but keep it low
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_AUTO
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input;
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) this.reset();
            else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeoutContext(function() {
                    this.state = STATE_RECOGNIZED;
                    this.tryEmit();
                }, options.time, this);
            } else if (input.eventType & INPUT_END) return STATE_RECOGNIZED;
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function(input) {
            if (this.state !== STATE_RECOGNIZED) return;
            if (input && input.eventType & INPUT_END) this.manager.emit(this.options.event + "up", input);
            else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ function RotateRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof RotateRecognizer
     */ defaults: {
            event: "rotate",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        }
    });
    /**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function SwipeRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof SwipeRecognizer
     */ defaults: {
            event: "swipe",
            threshold: 10,
            velocity: 0.3,
            direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
            pointers: 1
        },
        getTouchAction: function() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        },
        attrTest: function(input) {
            var direction = this.options.direction;
            var velocity;
            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) velocity = input.overallVelocity;
            else if (direction & DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
            else if (direction & DIRECTION_VERTICAL) velocity = input.overallVelocityY;
            return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        },
        emit: function(input) {
            var direction = directionStr(input.offsetDirection);
            if (direction) this.manager.emit(this.options.event + direction, input);
            this.manager.emit(this.options.event, input);
        }
    });
    /**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ function TapRecognizer() {
        Recognizer.apply(this, arguments);
        // previous time and center,
        // used for tap counting
        this.pTime = false;
        this.pCenter = false;
        this._timer = null;
        this._input = null;
        this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: "tap",
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 9,
            posThreshold: 10 // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_MANIPULATION
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();
            if (input.eventType & INPUT_START && this.count === 0) return this.failTimeout();
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType != INPUT_END) return this.failTimeout();
                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;
                if (!validMultiTap || !validInterval) this.count = 1;
                else this.count += 1;
                this._input = input;
                // if tap count matches we have recognized it,
                // else it has began recognizing...
                var tapCount = this.count % options.taps;
                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) return STATE_RECOGNIZED;
                    else {
                        this._timer = setTimeoutContext(function() {
                            this.state = STATE_RECOGNIZED;
                            this.tryEmit();
                        }, options.interval, this);
                        return STATE_BEGAN;
                    }
                }
            }
            return STATE_FAILED;
        },
        failTimeout: function() {
            this._timer = setTimeoutContext(function() {
                this.state = STATE_FAILED;
            }, this.options.interval, this);
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function() {
            if (this.state == STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Hammer(element, options) {
        options = options || {};
        options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
        return new Manager(element, options);
    }
    /**
 * @const {string}
 */ Hammer.VERSION = "2.0.7";
    /**
 * default settings
 * @namespace
 */ Hammer.defaults = {
        /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */ domEvents: false,
        /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */ touchAction: TOUCH_ACTION_COMPUTE,
        /**
     * @type {Boolean}
     * @default true
     */ enable: true,
        /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */ inputTarget: null,
        /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */ inputClass: null,
        /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */ preset: [
            // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
            [
                RotateRecognizer,
                {
                    enable: false
                }
            ],
            [
                PinchRecognizer,
                {
                    enable: false
                },
                [
                    "rotate"
                ]
            ],
            [
                SwipeRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                }
            ],
            [
                PanRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                },
                [
                    "swipe"
                ]
            ],
            [
                TapRecognizer
            ],
            [
                TapRecognizer,
                {
                    event: "doubletap",
                    taps: 2
                },
                [
                    "tap"
                ]
            ],
            [
                PressRecognizer
            ]
        ],
        /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */ cssProps: {
            /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userSelect: "none",
            /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */ touchSelect: "none",
            /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */ touchCallout: "none",
            /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */ contentZooming: "none",
            /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userDrag: "none",
            /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */ tapHighlightColor: "rgba(0,0,0,0)"
        }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Manager(element, options) {
        this.options = assign({}, Hammer.defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(this.options.recognizers, function(item) {
            var recognizer = this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    Manager.prototype = {
        /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */ set: function(options) {
            assign(this.options, options);
            // Options that need a little more setup
            if (options.touchAction) this.touchAction.update();
            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }
            return this;
        },
        /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */ stop: function(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        },
        /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */ recognize: function(inputData) {
            var session = this.session;
            if (session.stopped) return;
            // run the touch-action polyfill
            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers;
            // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`
            var curRecognizer = session.curRecognizer;
            // reset when the last recognizer is recognized
            // or when we're in a new session
            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) curRecognizer = session.curRecognizer = null;
            var i = 0;
            while(i < recognizers.length){
                recognizer = recognizers[i];
                // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.
                if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer || // 2
                recognizer.canRecognizeWith(curRecognizer))) recognizer.recognize(inputData);
                else recognizer.reset();
                // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer
                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) curRecognizer = session.curRecognizer = recognizer;
                i++;
            }
        },
        /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */ get: function(recognizer) {
            if (recognizer instanceof Recognizer) return recognizer;
            var recognizers = this.recognizers;
            for(var i = 0; i < recognizers.length; i++){
                if (recognizers[i].options.event == recognizer) return recognizers[i];
            }
            return null;
        },
        /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */ add: function(recognizer) {
            if (invokeArrayArg(recognizer, "add", this)) return this;
            // remove existing
            var existing = this.get(recognizer.options.event);
            if (existing) this.remove(existing);
            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        },
        /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */ remove: function(recognizer) {
            if (invokeArrayArg(recognizer, "remove", this)) return this;
            recognizer = this.get(recognizer);
            // let's make sure this recognizer exists
            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, recognizer);
                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }
            return this;
        },
        /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */ on: function(events, handler) {
            if (events === undefined) return;
            if (handler === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        },
        /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */ off: function(events, handler) {
            if (events === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                if (!handler) delete handlers[event];
                else handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            });
            return this;
        },
        /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */ emit: function(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) triggerDomEvent(event, data);
            // no handlers, so skip it all
            var handlers = this.handlers[event] && this.handlers[event].slice();
            if (!handlers || !handlers.length) return;
            data.type = event;
            data.preventDefault = function() {
                data.srcEvent.preventDefault();
            };
            var i = 0;
            while(i < handlers.length){
                handlers[i](data);
                i++;
            }
        },
        /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */ destroy: function() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        }
    };
    /**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function toggleCssProps(manager, add) {
        var element = manager.element;
        if (!element.style) return;
        var prop;
        each(manager.options.cssProps, function(value, name) {
            prop = prefixed(element.style, name);
            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else element.style[prop] = manager.oldCssProps[prop] || "";
        });
        if (!add) manager.oldCssProps = {};
    }
    /**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function triggerDomEvent(event, data) {
        var gestureEvent = document1.createEvent("Event");
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    assign(Hammer, {
        INPUT_START: INPUT_START,
        INPUT_MOVE: INPUT_MOVE,
        INPUT_END: INPUT_END,
        INPUT_CANCEL: INPUT_CANCEL,
        STATE_POSSIBLE: STATE_POSSIBLE,
        STATE_BEGAN: STATE_BEGAN,
        STATE_CHANGED: STATE_CHANGED,
        STATE_ENDED: STATE_ENDED,
        STATE_RECOGNIZED: STATE_RECOGNIZED,
        STATE_CANCELLED: STATE_CANCELLED,
        STATE_FAILED: STATE_FAILED,
        DIRECTION_NONE: DIRECTION_NONE,
        DIRECTION_LEFT: DIRECTION_LEFT,
        DIRECTION_RIGHT: DIRECTION_RIGHT,
        DIRECTION_UP: DIRECTION_UP,
        DIRECTION_DOWN: DIRECTION_DOWN,
        DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
        DIRECTION_VERTICAL: DIRECTION_VERTICAL,
        DIRECTION_ALL: DIRECTION_ALL,
        Manager: Manager,
        Input: Input,
        TouchAction: TouchAction,
        TouchInput: TouchInput,
        MouseInput: MouseInput,
        PointerEventInput: PointerEventInput,
        TouchMouseInput: TouchMouseInput,
        SingleTouchInput: SingleTouchInput,
        Recognizer: Recognizer,
        AttrRecognizer: AttrRecognizer,
        Tap: TapRecognizer,
        Pan: PanRecognizer,
        Swipe: SwipeRecognizer,
        Pinch: PinchRecognizer,
        Rotate: RotateRecognizer,
        Press: PressRecognizer,
        on: addEventListeners,
        off: removeEventListeners,
        each: each,
        merge: merge,
        extend: extend,
        assign: assign,
        inherit: inherit,
        bindFn: bindFn,
        prefixed: prefixed
    });
    // this prevents errors when Hammer is loaded in the presence of an AMD
    //  style loader but by script tag, not by the loader.
    var freeGlobal = typeof window1 !== "undefined" ? window1 : typeof self !== "undefined" ? self : {}; // jshint ignore:line
    freeGlobal.Hammer = Hammer;
    if (typeof define === "function" && define.amd) define(function() {
        return Hammer;
    });
    else if (0, $631a4ac5e6b8f660$exports) $631a4ac5e6b8f660$exports = Hammer;
    else window1[exportName] = Hammer;
})(window, document, "Hammer");


const $f68cc21601ce49bc$export$70fb2d88ab3fc3a6 = {
    38: 0,
    39: 1,
    40: 2,
    37: 3
};
class $f68cc21601ce49bc$export$2e2bcd8739ae039 {
    gameContainer;
    retryButton;
    events = {};
    constructor(options){
        this.gameContainer = options.gameContainer;
        this.retryButton = options.retryButton;
        this.events = {};
        this.listen();
    }
    on = (event, callback)=>{
        if (!this.events[event]) this.events[event] = [];
        this.events[event].push(callback);
    };
    bindKeyboardEvents = ()=>{
        document.addEventListener("keydown", (event)=>{
            const modifiers = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
            const mapped = $f68cc21601ce49bc$export$70fb2d88ab3fc3a6[event.which];
            if (modifiers) return;
            if (mapped !== undefined) {
                event.preventDefault();
                this.emit("move", mapped);
            }
            if (event.which === 32) this.restart();
        });
    };
    bindTouchEvents = ()=>{
        const handler = new $631a4ac5e6b8f660$exports(this.gameContainer, {
            recognizers: [
                [
                    $631a4ac5e6b8f660$exports.Swipe,
                    {
                        direction: $631a4ac5e6b8f660$exports.DIRECTION_ALL
                    }
                ]
            ]
        });
        const gestures = [
            $631a4ac5e6b8f660$exports.DIRECTION_UP,
            $631a4ac5e6b8f660$exports.DIRECTION_RIGHT,
            $631a4ac5e6b8f660$exports.DIRECTION_DOWN,
            $631a4ac5e6b8f660$exports.DIRECTION_LEFT
        ];
        handler.on("swipe", (event)=>{
            event.preventDefault();
            const mapped = gestures.indexOf(event.direction);
            if (mapped !== -1) this.emit("move", mapped);
        });
    };
    bindRestart = ()=>{
        this.retryButton.addEventListener("click", this.restart.bind(this));
    };
    listen = ()=>{
        this.bindKeyboardEvents();
        this.bindTouchEvents();
        this.bindRestart();
    };
    emit = (event, data)=>{
        const callbacks = this.events[event];
        if (!callbacks) return;
        callbacks.forEach((callback)=>callback(data));
    };
    restart = ()=>{
        this.emit("restart");
    };
}


class $d61a01b0b879627b$export$2e2bcd8739ae039 {
    size;
    score = 0;
    startTiles;
    isWin = false;
    isOver = false;
    grid = null;
    domUpdater;
    gestureManager;
    constructor(size, startTiles = 2){
        this.size = size;
        this.startTiles = startTiles;
        this.gestureManager = new (0, $f68cc21601ce49bc$export$2e2bcd8739ae039)({
            gameContainer: document.querySelector(".game"),
            retryButton: document.querySelector(".retry")
        });
        this.domUpdater = new (0, $fd629d3925992730$export$2e2bcd8739ae039)();
        // @ts-ignore
        this.gestureManager.on("move", this.move);
        this.gestureManager.on("restart", this.restart.bind(this));
        this.init();
    }
    init = ()=>{
        this.grid = new (0, $7bbf6eed0b3cd803$export$2e2bcd8739ae039)(this.size);
        this.score = 0;
        this.isOver = false;
        this.isWin = false;
        this.renderStartTiles();
        this.update();
    };
    restart = ()=>{
        this.domUpdater.restart();
        this.init();
    };
    renderStartTiles = ()=>{
        for(let i = 0; i < this.startTiles; i++)this.renderTile();
    };
    renderTile = ()=>{
        if (!this.grid || !this.grid.hasCellsAvailable()) return;
        const value = Math.random() < 0.9 ? 2 : 4;
        const tile = new (0, $960a2cfa9ab53929$export$2e2bcd8739ae039)(this.grid.getAvailableCell(), value);
        this.grid.insertTile(tile);
    };
    update = ()=>{
        if (!this.grid) return;
        this.domUpdater.update(this.grid, {
            score: this.score,
            isOver: this.isOver,
            isWin: this.isWin
        });
    };
    updateTiles = ()=>{
        if (!this.grid) return;
        this.grid.eachCell((x, y, tile)=>{
            if (tile) {
                tile.mergedFrom = null;
                tile.save();
            }
        });
    };
    moveTile = (tile, cell)=>{
        if (!this.grid) return;
        this.grid.cells[tile.x][tile.y] = null;
        this.grid.cells[cell.x][cell.y] = tile;
        tile.update(cell);
    };
    move = (direction)=>{
        if (this.isOver || this.isWin) return;
        let cell;
        let tile;
        let isMoved = false;
        const coordinates = this.getCoordinates(direction);
        const cellsInDirection = this.getCellsInDirection(coordinates);
        this.updateTiles();
        cellsInDirection.x.forEach((x)=>{
            cellsInDirection.y.forEach((y)=>{
                cell = {
                    x: x,
                    y: y
                };
                tile = this.grid.getCellContent(cell);
                if (tile) {
                    const positions = this.getLastPosition(cell, coordinates);
                    const next = this.grid.getCellContent(positions.next);
                    if (next && next.value === tile.value && !next.mergedFrom) {
                        const mergedTile = new (0, $960a2cfa9ab53929$export$2e2bcd8739ae039)(positions.next, tile.value * 2);
                        mergedTile.mergedFrom = [
                            tile,
                            next
                        ];
                        this.grid.insertTile(mergedTile);
                        this.grid.removeTile(tile);
                        tile.update(positions.next);
                        this.score += mergedTile.value;
                        if (mergedTile.value === 2048) this.isWin = true;
                    } else this.moveTile(tile, positions.last);
                    if (!this.arePositionsEqual(cell, tile)) isMoved = true;
                }
            });
        });
        if (isMoved) {
            this.renderTile();
            if (!this.hasMovesLeft()) this.isOver = true;
            this.update();
        }
    };
    getCoordinates = (direction)=>{
        const map = {
            0: {
                x: 0,
                y: -1
            },
            1: {
                x: 1,
                y: 0
            },
            2: {
                x: 0,
                y: 1
            },
            3: {
                x: -1,
                y: 0
            }
        };
        return map[direction];
    };
    getCellsInDirection = (coordinates)=>{
        const cellsInDirection = {
            x: [],
            y: []
        };
        for(let pos = 0; pos < this.size; pos++){
            cellsInDirection.x.push(pos);
            cellsInDirection.y.push(pos);
        }
        if (coordinates.x === 1) cellsInDirection.x = cellsInDirection.x.reverse();
        if (coordinates.y === 1) cellsInDirection.y = cellsInDirection.y.reverse();
        return cellsInDirection;
    };
    getLastPosition = (cell, coordinates)=>{
        let previous;
        do {
            previous = cell;
            cell = {
                x: previous.x + coordinates.x,
                y: previous.y + coordinates.y
            };
        }while (this.grid.isInBounds(cell) && this.grid.isCellAvailable(cell));
        return {
            last: previous,
            next: cell
        };
    };
    hasMovesLeft = ()=>this.grid.hasCellsAvailable() || this.tileMatchesAvailable();
    tileMatchesAvailable = ()=>{
        let tile;
        for(let x = 0; x < this.size; x++)for(let y = 0; y < this.size; y++){
            tile = this.grid.getCellContent({
                x: x,
                y: y
            });
            if (!tile) continue;
            for(let direction = 0; direction < this.size; direction++){
                const coordinates = this.getCoordinates(direction);
                const cell = {
                    x: x + coordinates.x,
                    y: y + coordinates.y
                };
                const other = this.grid.getCellContent(cell);
                if (other && other.value === tile.value) return true;
            }
        }
        return false;
    };
    arePositionsEqual = (first, second)=>first.x === second.x && first.y === second.y;
}


window.requestAnimationFrame(()=>new (0, $d61a01b0b879627b$export$2e2bcd8739ae039)(4));
var $bda5883e2d5c7309$exports = {};
$bda5883e2d5c7309$exports = new URL("scripts/service-worker.js", import.meta.url).toString();


if ("serviceWorker" in navigator) window.addEventListener("load", ()=>{
    navigator.serviceWorker.register($bda5883e2d5c7309$exports);
});


//# sourceMappingURL=index.a5862d96.js.map
